import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {
    ManagerCachingStrategy,
    PropertyMap,
    ReadWrite
} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {BaseEntity} from "../base-entity.model";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {ExactSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {ArchivoBlenderSecundaria} from "../archivos/archivo-blender-secundaria.model";
import {MetodoFabricacion} from "../materiales/metodo-fabricacion.model";
import {Material} from "../materiales/material.model";
import {LineaPedido} from "../pedidos/linea-pedido.model";

@BasicEntity({
    name: 'Blender Secundaria',
    endpoint: 'blender_secundarias',
    modelNameProperty: 'resumen',
    isPaginated: true,
    managerCaching: ManagerCachingStrategy.Lazy,
    type: "BlenderSecundaria"
})
export class BlenderSecundaria extends BaseEntity {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: string;

    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender',
        type: PropertyType.FutureUri('blender.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(BlenderSecundaria.BLENDER_MAP)
    private _blender;

    @BasicProperty({
        name: 'Archivos',
        type: PropertyType.NestedModel(ArchivoBlenderSecundaria, 'blenderSecundaria', NestedBehavior.SendIriOnly),
        array: true
    })
    private _archivos: ArchivoBlenderSecundaria[];

    @BasicProperty({
        name: 'Método',
        type: PropertyType.NestedModel(MetodoFabricacion, undefined, NestedBehavior.SendIriOnly),
        filters: [ExactSearchFilter]
    })
    private _metodoFabricacion: MetodoFabricacion;

    @BasicProperty({
        name: 'Material',
        type: PropertyType.NestedModel(Material, undefined, NestedBehavior.SendIriOnly),
        filters: [ExactSearchFilter]
    })
    private _material: Material;

    @BasicProperty({
        name: 'Fabricar',
        type: PropertyType.Boolean()
    })
    private _fabricar = false;

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get blender() {
        return this._blender;
    }

    set blender(value) {
        this._blender = value;
    }

    get archivos(): ArchivoBlenderSecundaria[] {
        return this._archivos;
    }

    set archivos(value: ArchivoBlenderSecundaria[]) {
        this._archivos = value;
    }

    get metodoFabricacion(): MetodoFabricacion {
        return this._metodoFabricacion;
    }

    set metodoFabricacion(value: MetodoFabricacion) {
        this._metodoFabricacion = value;
    }

    get material(): Material {
        return this._material;
    }

    set material(value: Material) {
        this._material = value;
    }

    get fabricar(): boolean {
        return this._fabricar;
    }

    set fabricar(value: boolean) {
        this._fabricar = value;
    }
}

ArchivoBlenderSecundaria.BLENDER_MAP.type = PropertyType.Uri(BlenderSecundaria)
